module.exports = __webpack_public_path__ + "static/prebid-3ce98d9048189bd86c10f16a77642717.png";